import ApiBase from '../api-base'
import {ACTIVE_BASE_REST} from '../constants'
export default class Roles extends ApiBase {
  constructor (store) {
    const path = ACTIVE_BASE_REST + '/security/role'
    super(store, path)
  }
}